<template>
  <div>
    <div class="delayedTrucksTable roundedBorder">
      <el-table :data="totalRoutes" height="100%">
        <el-table-column
          label="Patente"
          fixed="left"
          min-width="110"
          align="center">
          <template slot-scope="scope">
            {{ scope.row.vehicle.patent }}
          </template>
        </el-table-column>
        <el-table-column
          label="CD/CT/CTT"
          min-width="180"
          align="center">
          <template slot-scope="scope">
            {{ scope.row.distribution_center.name}}
          </template>
        </el-table-column>
        <el-table-column
          label="Puntos"
          align="center">
          <template slot-scope="scope">
            {{ scope.row.delivery_points | len}}
          </template>
        </el-table-column>
        <el-table-column
          label="Inicio"
          min-width="180px"
          align="center">
          <template slot-scope="scope">
            {{ scope.row.start_time | moment}} hrs
          </template>
        </el-table-column>
        <el-table-column
          label="Término"
          min-width="180px"
          align="center">
          <template slot-scope="scope">
            {{ scope.row.estimated_finish_time | moment}} hrs
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="Detalle"
          width="75px">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.active"
              type="text"
              @click="selectRoute(scope.row.vehicle.patent)">Ver más</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'TracingRoutesTable',
  props: {
    routes: {
      type: Array,
    },
  },
  data() {
    return {
      totalRoutes: [],
    };
  },
  methods: {
    selectRoute(patent) {
      this.$emit('clickPatent', patent);
    },
    setData() {
      // eslint-disable-next-line prefer-destructuring
      this.totalRoutes = this.routes[0];
    },
  },
  filters: {
    moment(time) {
      if (time) {
        const date = moment(time).format('HH:mm:ss');
        return date;
      }
      return '';
    },
    len(data) {
      if (data) {
        return data.length;
      }
      return 0;
    },
  },
  watch: {
    routes() {
      this.setData();
    },
  },
};
</script>

<style lang="scss" scoped>
  .roundedBorder {
    border: 1px solid #E0E0E0;
    box-sizing: border-box;
    border-radius: 3px;
    background: white;
    height: 275px;
  }
  .el-button.el-button--text {
    color: #a5a5a5;
    font-weight: bold;
    :hover {
      color: $fb-green;
    };
  }
  @media only screen and (max-width: 1200px) {
    .roundedBorder {
      height: 415px;
    }
  }

</style>
